import { DemoFontOptionKey, DemoFontOption } from './types';
import fonts from '../../../../utils/joyFonts.json';
import { Layout } from '@graphql/types';
import { LocationPalette } from '../DesignDemo/types';
import uuid from 'uuid';

export const ACCEPTED_LAYOUT_VALUES = new Set<Layout>([Layout.aloha, Layout.brannan]);

export const BASE_FONT_KEYS: DemoFontOptionKey[] = fonts.map((font: DemoFontOption) => font.key);

export const BASE_FONTS: DemoFontOption[] = BASE_FONT_KEYS.map(key => ({
  key,
  fontFamily: fonts.find((font: DemoFontOption) => font.key === key).fontFamily
}));

const COLOR_EGGSHELL_RGBA = [0.956, 0.952, 0.904, 1];
const COLOR_OFF_BLACK_RGBA = [0.204, 0.204, 0.204, 1];
export const DEFAULT_PALETTE: LocationPalette = {
  paletteId: uuid(),
  paletteName: 'My Custom Color',
  accentColor: COLOR_EGGSHELL_RGBA,
  baseText: COLOR_OFF_BLACK_RGBA,
  baseColor: COLOR_EGGSHELL_RGBA,
  accentText: COLOR_OFF_BLACK_RGBA,
  accentLightText: false,
  baseLightText: false
};

export const DEFAULT_THEME = 'midnight_peony';
